import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  cover: any="";
  name: any="";
  image:any="";
  appname:any="";

  constructor(
    private router: Router   
    ) { 
      this.cover=localStorage.getItem('cover');
      this.name=localStorage.getItem('name')
      this.image=localStorage.getItem('image')
      this.appname=localStorage.getItem('appname')
    }


  redirect(path) {
    this.router.navigate([path]);
  }

  openprofile()
  {
    this.router.navigate(['myprofile'] );
  }

  ngOnInit() {
    this.checkImageUpdate();
  }
  
  checkImageUpdate() {
    setInterval(() => {
      const updatedImage = localStorage.getItem('image');
      if (updatedImage !== this.image) {
        this.image = updatedImage;
      }
    }, 1000); // checks every 1 second
  }
  
}
